import { marketingClient } from "@trueskin-web/apis"
import { Trans, useTranslation } from "@trueskin-web/translations"

import EditQuestionnaire from "../edit-questionnaire"
import UserNote from "../user-note"

import Card from "./card"

const SkinAnalysis = () => {
  const { t } = useTranslation()

  const handleQReviewClose = () => {
    marketingClient.trackEvent({
      name: marketingClient.EVENT_TYPES_ENUM.WELCOME_BACK_Q_REVIEW_CLOSE,
    })
  }

  return (
    <Card status="completed" dataTestId="wb-steps-skin-analysis">
      <EditQuestionnaire
        title={t("Start.WelcomeBack.Steps.SkinAnalysis.title")}
        onClose={handleQReviewClose}
      >
        <div sx={{ pr: 6 }}>
          <Trans i18nKey="Start.WelcomeBack.Steps.SkinAnalysis.description" />
        </div>
      </EditQuestionnaire>

      <UserNote />
    </Card>
  )
}

export default SkinAnalysis
